import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.post("/api/rp-demand", params);
};

const getAllForCSV = params => {
  return restApiRP.post("/api/rp-demand", params);
};

const rpDemandService = {
  getAll,
  getAllForCSV
};

export default rpDemandService;